__turbopack_context__.v({
  "tableData": "MultiFormUploadConfirmationDialog-module__FLdKEG__tableData",
});
